export default class MediaIndexController {

    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;
        this.currentSelectedFile = null;
        this.usersStore = this.injector.get('Users');
    }

    handleFileSelection(file) {
        console.log(file);
    }
}

MediaIndexController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/media/controllers/index-controller.js